class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);



function getWishlist() {
  const list = localStorage.getItem("wishlist");
  return list ? JSON.parse(list) : [];
}

function saveWishlist(list) {
  localStorage.setItem("wishlist", JSON.stringify(list));
}

document.addEventListener("click", function(e) {
  // Open drawer when wishlist button clicked
  const btn = e.target.closest("#cart_wishlist_btn");
  if (btn) {
    e.preventDefault();

    var customerEmail = $("#cart_wishlist_btn").attr("customer-email");
    if (!customerEmail) {
      $("#loginPopup").fadeIn();
      return;
    }

    fetch(`https://shopify.elleven.in/wishlist/getdatabyuser/${customerEmail}`, { method: "GET" })
      .then((res) => res.json())
      .then((result) => {
        if (!result.success || !result.data || !result.data.variantid || result.data.variantid.length === 0) {
          $("#wishlistPage").html("<p>No items in your wishlist.</p>");
          const cartWishListButton = document.querySelector("#cart_wishlist_btn");
          if (cartWishListButton) {
            cartWishListButton.style.display = "none";
          }
          return;
        }

        // Map raw items
        var apiItems = result.data.variantid.map(function (item) {
          return {
            variantId: item.id ? String(item.id).replace("gid://shopify/ProductVariant/", "") : "",
            priceRaw: item.price !== undefined ? Number(item.price) : 0,
            compareRaw: item.compareAtPrice !== undefined ? Number(item.compareAtPrice) : 0,
            productTitle: item.product ? item.product.title : "",
            productHandle: item.product ? item.product.handle : "",
            productImage: item.product && item.product.images && item.product.images[0] ? item.product.images[0].url : "",
            variantTitle: item.title || "",
            customerEmail: result.data.useremail || "",
            wishlistDate: result.data.wishlist_date || "",
            productId: item.product && item.product.id 
              ? String(item.product.id).replace("gid://shopify/Product/", "") 
              : "",
            customerPhone: document.querySelector("#cart_wishlist_btn").getAttribute("customer-phone")
          };
        });

        // Heuristic detection
        var paiseCount = 0;
        var fractionFound = false;
        apiItems.forEach(function (it) {
          if (!Number.isFinite(it.priceRaw)) it.priceRaw = 0;
          if (!Number.isFinite(it.compareRaw)) it.compareRaw = 0;
          if (!Number.isInteger(it.priceRaw) || !Number.isInteger(it.compareRaw)) {
            fractionFound = true;
          }
          if (Math.abs(it.priceRaw) >= 100000 || Math.abs(it.compareRaw) >= 100000) {
            paiseCount++;
          }
        });

        var treatAsPaise = fractionFound ? false : paiseCount > apiItems.length / 2;

        function rawToRupees(raw) {
          if (!Number.isFinite(raw)) return 0;
          return treatAsPaise ? (raw / 100) : raw;
        }
        function limitChars(str, limit) {
          return str.length > limit ? str.substring(0, limit) + "..." : str;
        }
        function formatINRNumber(rupeeNumber) {
          return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(rupeeNumber);
        }
        
        $("#wishlist-items").empty();
        apiItems.forEach(function (item) {
          var priceR = rawToRupees(item.priceRaw);
          var compareR = rawToRupees(item.compareRaw);

          var compareHtml = "";
          var discountHtml = "";
          if (compareR > priceR && compareR > 0) {
            compareHtml = `<p class="compare-price">${formatINRNumber(compareR)}</p>`;
            var discountPercent = Math.round(((compareR - priceR) / compareR) * 100);
            var savings = compareR - priceR;
            discountHtml = `<span class="discount__percentage__grid font-bold">- ${discountPercent}% (Save - ${formatINRNumber(savings)})</span>`;
          }

          var productHtml = `
            <div class="wishlist-item">
            <button 
              class="wishlist_remove_btn" 
              data-variant-id="${item.variantId}" 
              data-product-id="${item.productId}"
              data-wishlist-date="${item.wishlistDate || ""}"
              data-email="${item.customerEmail}" 
              data-phone="${item.customerPhone}"
            >✖</button>
              <a href="/products/${item.productHandle}" class="view-product">
                <img class="wishlisht_prd_img" src="${item.productImage}" alt="${item.productTitle}">
                <h4>${limitChars(item.productTitle, 50)} (${item.variantTitle})</h4>
                <div class="wishlist_card_price">
                  ${compareHtml}
                  <p class="final-price">${formatINRNumber(priceR)}</p>
                  ${discountHtml}
                </div>
              </a>
              
              <button class="wishlist_add_to_cart product-form__submit button button--secondary button--full-width cstm__card_button" variant_id="${item.variantId}">Add To Cart</button>
            </div>
          `;
          $("#wishlist-items").append(productHtml);
        });
      })
      .catch((err) => {
        console.error("API Fetch Error:", err);
        $("#wishlistPage").html("<p>Error loading wishlist. Please try again later.</p>");
      });

    // Finally open the drawer
    const drawer = document.getElementById("wishlist-drawer");
    if (drawer) {
      drawer.setAttribute("aria-hidden", "false");
      drawer.classList.add("open");
      document.body.classList.add("drawer-open");
    }
  }

  // Close drawer when backdrop or close button clicked
  if (e.target.matches("[data-drawer-close]")) {
    const drawer = document.getElementById("wishlist-drawer");
    if (drawer) {
      drawer.setAttribute("aria-hidden", "true");
      drawer.classList.remove("open");
      document.body.classList.remove("drawer-open"); 
    }
  }
});

// Close login popup on close button click
$(document).on("click", "#loginPopup .close-btn", function() {
  $("#loginPopup").fadeOut();
});

$(document).on("click", ".wishlist_remove_btn", function () {
  const $button = $(this);
  const variantId = String($button.data("variant-id"));
  const productId = $button.data("product-id");
  const wishlistDate = $button.data("wishlist-date") || "";
  const customerEmail = $button.data("email");
  const customerPhone = $button.data("phone") || "";

  $button.addClass("loading");

  // Remove item from local storage
  let wishlist = getWishlist();
  wishlist = wishlist.filter((item) => String(item.variantId) !== variantId);
  saveWishlist(wishlist);
  const remainingVariantIds = wishlist.map((item) => item.variantId);

  // Update wishlist via POST API
  function updateWishlistAPI(email, phone, variantIds, productId, wishlistDate) {
    const payload = {
      useremail: email || "Guest",
      variantids: variantIds,
      phone: phone || "",
      productid: productId || "",
      wishlist_date: wishlistDate || "",
    };

    return fetch("https://shopify.elleven.in/wishlist/addwishlistdata", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`POST API failed with status: ${response.status}`);
        }
        const text = await response.text();
        try {
          return JSON.parse(text);
        } catch (err) {
          console.error("JSON parse error:", err, text);
          throw err;
        }
      });
  }

  // Refresh wishlist UI via GET API
  function refreshWishlist(email) {
    $("#wishlist-items").html('<p>Loading...</p>'); 

    fetch(`https://shopify.elleven.in/wishlist/getdatabyuser/${email}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (!result.success || !result.data || !result.data.variantid || result.data.variantid.length === 0) {
          $("#wishlist-items").html("<p>No items in your wishlist.</p>");
          const cartWishListButton = document.querySelector("#cart_wishlist_btn");
          const wishlistDrawer = document.querySelector("#wishlist-drawer");
          if (cartWishListButton) {
            cartWishListButton.style.display = "none";
          }
          if (wishlistDrawer) {
            wishlistDrawer.classList.remove("open");
          }
          return;
        }

        const apiItems = result.data.variantid.map((item) => ({
          variantId: item.id ? String(item.id).replace("gid://shopify/ProductVariant/", "") : "",
          priceRaw: item.price !== undefined ? Number(item.price) : 0,
          compareRaw: item.compareAtPrice !== undefined ? Number(item.compareAtPrice) : 0,
          productTitle: item.product ? item.product.title : "",
          productHandle: item.product ? item.product.handle : "",
          productImage: item.product && item.product.images && item.product.images[0] ? item.product.images[0].url : "",
          variantTitle: item.title || "",
          productId: item.product && item.product.id
            ? String(item.product.id).replace("gid://shopify/Product/", "")
            : "",
          product_checker: item.availableForSale || false,
          wishlistDate: result.data.wishlist_date || "",
          customerEmail: result.data.useremail || "",
          customerPhone: result.data.phone || customerPhone,
        }));

        // Price handling
        const treatAsPaise = apiItems.some((it) => Math.abs(it.priceRaw) >= 100000 && Number.isInteger(it.priceRaw));

        function rawToRupees(raw) {
          return Number.isFinite(raw) ? (treatAsPaise ? raw / 100 : raw) : 0;
        }

        function limitChars(str, limit) {
          return str.length > limit ? str.substring(0, limit) + "..." : str;
        }

        function formatINRNumber(rupeeNumber) {
          return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(rupeeNumber);
        }

        $("#wishlist-items").empty();
        apiItems.forEach((item) => {
          const priceR = rawToRupees(item.priceRaw);
          const compareR = rawToRupees(item.compareRaw);

          let compareHtml = "";
          let discountHtml = "";
          if (compareR > priceR && compareR > 0) {
            compareHtml = `<p class="compare-price">${formatINRNumber(compareR)}</p>`;
            const discountPercent = Math.round(((compareR - priceR) / compareR) * 100);
            const savings = compareR - priceR;
            discountHtml = `<span class="discount__percentage__grid font-bold">- ${discountPercent}% (Save - ${formatINRNumber(savings)})</span>`;
          }

          const productHtml = `
            <div class="wishlist-item">
              <button 
                class="wishlist_remove_btn" 
                data-variant-id="${item.variantId}" 
                data-product-id="${item.productId}"
                data-wishlist-date="${item.wishlistDate || ''}"
                data-email="${item.customerEmail}" 
                data-phone="${item.customerPhone}"
              >✖</button>
              <a href="/products/${item.productHandle}" class="view-product" checker="${item.product_checker}">
                <img class="wishlisht_prd_img" src="${item.productImage}" alt="${item.productTitle}">
                <h4>${limitChars(item.productTitle, 25)} (${item.variantTitle})</h4>
                <div class="wishlist_card_price">
                  ${compareHtml}
                  <p class="final-price">${formatINRNumber(priceR)}</p>
                  ${discountHtml}
                </div>
              </a>
              ${
                item.product_checker
                  ? `<button class="wishlist_add_to_cart product-form__submit button button--secondary button--full-width" variant_id="${item.variantId}">Add To Cart</button>`
                  : `<button class="wishlist_add_to_cart product-form__submit button button--secondary button--full-width disabled" disabled variant_id="${item.variantId}">Sold Out</button>`
              }
            </div>`;
          $("#wishlist-items").append(productHtml);
        });
        var list = localStorage.getItem("wishlist");
        const wishlistData = list ? JSON.parse(list) : [];
        const cartWishListButton = document.querySelector("#cart_wishlist_btn");
        const wishlistDrawer = document.querySelector("#wishlist-drawer");
        if (cartWishListButton) {
          cartWishListButton.style.display = (wishlistData.length === 0 ? "none" : "flex");
        }
        if (wishlistDrawer) {
          if (wishlistData.length === 0) {wishlistDrawer.classList.remove("open")}
        }
      })
      .catch((err) => {
        console.error("GET API Fetch Error:", err);
        $("#wishlist-items").html("<p>Error loading wishlist. Please try again later.</p>");
      })
      .finally(() => {
        $button.removeClass("loading");
      });
  }

  // Execute POST API and then refresh wishlist
  updateWishlistAPI(customerEmail, customerPhone, remainingVariantIds, productId, wishlistDate)
    .then((data) => {
      if (data.success) {
        refreshWishlist(customerEmail);
      } else {
        $("#wishlistPage").html("<p>Failed to update wishlist. Please try again.</p>");
        $button.removeClass("loading");
      }
    })
    .catch((error) => {
      console.error("POST API Fetch Error:", error);
      $("#wishlistPage").html("<p>Error updating wishlist. Please try again later.</p>");
      $button.removeClass("loading");
    });
});

$('body').on('click', '.wishlist_add_to_cart', function() {
  var id = $(this).attr('variant_id');
  var $button = $(this);
  if (!id) {
    console.log('No variant ID found.');
  } else {
    $button.addClass('loading');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: id,
        quantity: 1,
      },
      dataType: 'json',
      success: function(response) {
        $.getJSON('/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble').then(sections => {
          const minicart = document.querySelector('mini-cart');
          response.sections = sections;
          minicart.renderContents(response);
          $button.removeClass('loading');
          $('.main__cart_card').hide();
        });
      },
      error: function() {
        console.log('There was an error adding the item to the cart.');
        $button.removeClass('loading');
        $('.main__cart_card').hide();
      }
    });
  }
});
